import { AxiosResponse } from 'axios'
import { get, post, upload, patch, del } from '../../utils/api'
import { FormDataType } from './types'

export const fetchContest = (): Promise<AxiosResponse> =>
  get('/contests/current', {
    include: ['nominations', 'fields', 'ageCategories'].join(','),
  })

export const sendWork = (data: FormDataType): Promise<AxiosResponse> =>
  post('/contests/works/my', data)

export const updateWork = (
  work_id: string,
  data: FormDataType
): Promise<AxiosResponse> => patch(`/contests/works/my/${work_id}`, data)

export const uploadFile = (
  file: File,
  uploadProgress: (percent: number) => void
): Promise<AxiosResponse> =>
  upload(
    '/temporary-files',
    {
      field: 'file',
      item: file,
    },
    {},
    {},
    percent => uploadProgress(percent)
  )

export const removeFile = (file_id: string): Promise<AxiosResponse> =>
  del(`/temporary-files/${file_id}`)

export const removeFileFromWork = (
  wid: string,
  file_id: string
): Promise<AxiosResponse> =>
  del(`/contests/works/my/${wid}/attachments/${file_id}`)

export const fetchMyWork = (work_id: string): Promise<AxiosResponse> =>
  get(`/contests/works/my/${work_id}`, {
    include: [
      'user',
      'contest',
      'nomination',
      'ageCategory',
      'attachments',
      'answers',
    ].join(','),
  })
